import { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

interface AuthFrameProps extends HTMLAttributes<HTMLDivElement> {
}

export function InstallflowFrame({ className, ...props }: AuthFrameProps) {

  return (
    <div className="w-full h-full animate-bg-pan-br">
      <div className="flex items-center justify-center h-screen p-6 w-full">
        <div className="flex flex-col items-center justify-center ">
          <div className={cn("col-span-12 lg:col-span-12 flex justify-center max-w-[350px]", className)} {...props} >
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}
